import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { SPACING } from "@/design-system";

interface FAQAccordionSkeletonProps {
  count?: number;
  className?: string;
}

/**
 * FAQAccordionSkeleton - Matches the exact layout of FAQ accordions in HelpCenter.tsx
 * 
 * Structure per item:
 * - Container with border and px-6 py-4
 * - Question line (h-5 w-3/4)
 * - Chevron placeholder (h-4 w-4)
 */
export function FAQAccordionSkeleton({ count = 5, className }: FAQAccordionSkeletonProps) {
  return (
    <div className={cn(SPACING.cardContent, className)}>
      {[...Array(count)].map((_, i) => (
        <div key={i} className="border rounded-lg px-6 py-4 bg-card">
          <div className="flex justify-between items-center">
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="h-4 w-4" />
          </div>
        </div>
      ))}
    </div>
  );
}
